import { render, staticRenderFns } from "./my_bind_licence.vue?vue&type=template&id=c5670998"
import script from "./my_bind_licence.vue?vue&type=script&lang=js"
export * from "./my_bind_licence.vue?vue&type=script&lang=js"
import style0 from "./my_bind_licence.vue?vue&type=style&index=0&id=c5670998&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports